import React from 'react';
import { Flex } from 'rebass';
import { withRouter } from 'react-router';
import queryString from 'query-string';
import Frame from 'components/Frame';
import AddCandidateByLinkForm from 'modules/Candidates/components/AddCandidateByLinkForm';

const AddCandidateByLink: React.FC<any> = ({ location }): JSX.Element => {
  const parsed = queryString.parse(location.search);
  return (
    <>
      <Frame>
        <Flex width="100%" flexDirection="column">
          <AddCandidateByLinkForm userId={parsed.by} jobPostId={parsed.for} />
        </Flex>
      </Frame>
    </>
  );
};

export default withRouter(AddCandidateByLink);
